/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Lock_StatusInputs */

const en_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lock Status`)
};

const fr_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut de verrouillage`)
};

const de_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sperrstatus`)
};

const it_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato di blocco`)
};

const ru_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус блокировки`)
};

const es_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de bloqueo`)
};

const zh_cn2_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锁定状态`)
};

const ja_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロックステータス`)
};

const hi_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉक स्थिति`)
};

const pt_pt2_explorer_info_property_lock_status = /** @type {(inputs: Explorer_Info_Property_Lock_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status de bloqueio`)
};

/**
* | output |
* | --- |
* | "Lock Status" |
*
* @param {Explorer_Info_Property_Lock_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_lock_status = /** @type {((inputs?: Explorer_Info_Property_Lock_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Lock_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_lock_status(inputs)
	if (locale === "de") return de_explorer_info_property_lock_status(inputs)
	if (locale === "it") return it_explorer_info_property_lock_status(inputs)
	if (locale === "ru") return ru_explorer_info_property_lock_status(inputs)
	if (locale === "es") return es_explorer_info_property_lock_status(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_lock_status(inputs)
	if (locale === "ja") return ja_explorer_info_property_lock_status(inputs)
	if (locale === "hi") return hi_explorer_info_property_lock_status(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_lock_status(inputs)
	return en_explorer_info_property_lock_status(inputs)
});